<template>
    
    <div class="main">
      <div class="backImg"></div>
      <div class="login" >
        <el-form :model="ChatAdmin" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="login-main">
          <el-row>
              <el-col :span="24"><div class="grid-content bg-purple-dark" style="text-align: center; color: #3382f9;">
                  <i class="el-icon-user-solid" style="font-size: 30px;"></i><h2>视弘文创授权管理系统</h2>
  
              </div></el-col>
          </el-row>
          <el-form-item prop="username">
              <el-input type="text" prefix-icon="el-icon-user" v-model="ChatAdmin.username" auto-complete="off" placeholder="账号" ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input type="password"  prefix-icon="el-icon-unlock" v-model="ChatAdmin.password" auto-complete="off" placeholder="密码" ></el-input>
          </el-form-item>

          <el-form-item  >
            <el-row :gutter="20">
                <el-col :span="10"><el-input type="text" v-model="CaptchaJson.captchaValue" auto-complete="off" placeholder="验证码" prop="captchaValue" ></el-input></el-col>
                <el-col :span="14">     <img :src=" captchaImage"  @click="refreshCaptcha" /></el-col>
 
            </el-row>
            
       
          </el-form-item>
          <el-form-item class="btn-box">
            <el-button type="primary" @click="submitLogin('ruleForm')" style="width: 45%;float: left; background-color:#3382f9;border: none;">登录</el-button>
            <el-button @click="resetForm('ruleForm')" style="width: 45%;float: right; ">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
     
    </template>
    
    <script>
    export default {
      data () {
        return {
          captchaImage: '',
        CaptchaJson:{
          captchaKey:'',
          captchaValue: ''
       },
          ChatAdmin: {
            username: '',
            password: ''
          },
        
          rules: {
            username: [
              { required: true, message: '请输入账号', trigger: 'blur' },
              { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
            ],
            password: [
              { required: true, message: '请输入密码', trigger: 'blur' }
            ],
            captchaValue:[
              { required: true, message: '请输入验证码', trigger: 'blur' }
            ]
          }
        }
      },
      created() {
    this.refreshCaptcha();
  },
     
      methods: {
        
        refreshCaptcha() {
          this.request.get('/captcha').then(response => {
        
            if(response .code=='0'){
              const myMap = new Map(Object.entries(response.map));
              for (const [key, value] of myMap) {
                    console.log(key, value);
                    this.CaptchaJson.captchaKey=key
                    this.captchaImage=value
                }
                  
            }
        
            });
        },
      
        submitLogin (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.request.post("/verify",this.CaptchaJson).then(response => {
              console.log(response)
            if (response.code=='0') {
                // 验证成功的处理
              console.log('验证码验证成功');
              this.request.post("/userLogin", this.ChatAdmin).then(res => {
                          if(res.code=='0'){
                                    this.$message({message: '登录成功',type: 'success'});
                                    window.sessionStorage.setItem('token',JSON.stringify(res.data))
                                    window.sessionStorage.setItem('username',this.ChatAdmin.username)
                                    this.$router.push('/home');
                                }else{
                                  this.$message.error(res.msg);
                                }
              });
            } else {
          // 验证失败的处理
              console.log('验证码验证失败');
              this.$message.error(response.msg);
              this.refreshCaptcha();
            }
          });

            }else {
              console.log('error submit!!')
              return false
            }
          })
        },
        resetForm (formName) {
          this.$refs[formName].resetFields()
        }

      }

   
    }
    </script>
    <style scoped>
    .backImg {
    background-color: #3382f9;
      background-size: 100% 100%;
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
    .login {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      
      background: #fff;
      width: 20%;
      padding: 20px 20px 25px 20px;
      border-radius: 10px;
    }
    .login .list {
    display: flex;
    align-items: center;
    padding: 8px 0;
  }
  .login .list .input input{
    border-radius: 3px;
    border: none;
    outline: none;
    color: #999;
    border: 1px solid #bdbdbd;
    font-size: 14px;
    line-height: 35px;
    padding: 0 10px;
    display: block;
    box-sizing: border-box;
    flex: 7;
  }
  
  .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col {
      border-radius: 4px;
    }
    .bg-purple-dark {
    
    }
    .bg-purple {
      background: #d3dce6;
    }
    .bg-purple-light {
      background: #e5e9f2;
    }
    .grid-content {
  
      min-height: 36px;
    }
    .row-bg {
      padding: 10px 0;
      
      
    }
  
    </style>
  
    